"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.halSettings = exports.halFilters = exports.halUserWithAuthResponse = void 0;
const halUserWithAuthResponse = (user) => {
    const { filters, settings, ...rest } = user;
    const defaultFilter = filters.find((filter) => filter.id === settings.defaultFilter);
    return {
        ...rest,
        settings: (0, exports.halSettings)(settings, defaultFilter),
        filters: filters.map(exports.halFilters),
        _links: {
            self: { href: '/api/v1/user' },
            'p:filters': { href: '/api/v1/user/filters' },
            'p:settings': { href: '/api/v1/user/settings' },
        },
    };
};
exports.halUserWithAuthResponse = halUserWithAuthResponse;
const halFilters = (filter) => {
    const { id, ...rest } = filter;
    return {
        filters: rest,
        id,
        _links: { self: { href: `/api/v1/user/filters/${filter.id}` } },
    };
};
exports.halFilters = halFilters;
const halSettings = (settings, defaultFilter) => {
    const { defaultFilter: _, ...rest } = settings;
    return {
        ...rest,
        ...defaultFilter && { defaultFilter: (0, exports.halFilters)(defaultFilter) },
        _links: { self: { href: '/api/v1/user/settings' } },
    };
};
exports.halSettings = halSettings;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvdXNlci5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFrRk8sTUFBTSx1QkFBdUIsR0FBRyxDQUFDLElBQTBCLEVBQTJCLEVBQUU7SUFDN0YsTUFBTSxFQUNKLE9BQU8sRUFDUCxRQUFRLEVBQ1IsR0FBRyxJQUFJLEVBQ1IsR0FBRyxJQUFJLENBQUE7SUFDUixNQUFNLGFBQWEsR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsQ0FBQyxNQUFNLENBQUMsRUFBRSxLQUFLLFFBQVEsQ0FBQyxhQUFhLENBQUMsQ0FBQTtJQUVwRixPQUFPO1FBQ0wsR0FBRyxJQUFJO1FBQ1AsUUFBUSxFQUFFLElBQUEsbUJBQVcsRUFBQyxRQUFRLEVBQUUsYUFBYSxDQUFDO1FBQzlDLE9BQU8sRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLGtCQUFVLENBQUM7UUFDaEMsTUFBTSxFQUFFO1lBQ04sSUFBSSxFQUFFLEVBQUUsSUFBSSxFQUFFLGNBQWMsRUFBRTtZQUM5QixXQUFXLEVBQUUsRUFBRSxJQUFJLEVBQUUsc0JBQXNCLEVBQUU7WUFDN0MsWUFBWSxFQUFFLEVBQUUsSUFBSSxFQUFFLHVCQUF1QixFQUFFO1NBQ2hEO0tBQ0YsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQWxCWSxRQUFBLHVCQUF1QiwyQkFrQm5DO0FBRU0sTUFBTSxVQUFVLEdBQUcsQ0FBQyxNQUFvQixFQUFjLEVBQUU7SUFDN0QsTUFBTSxFQUNKLEVBQUUsRUFDRixHQUFHLElBQUksRUFDUixHQUFHLE1BQU0sQ0FBQTtJQUVWLE9BQU87UUFDTCxPQUFPLEVBQUUsSUFBSTtRQUNiLEVBQUU7UUFDRixNQUFNLEVBQUUsRUFBRSxJQUFJLEVBQUUsRUFBRSxJQUFJLEVBQUUsd0JBQXdCLE1BQU0sQ0FBQyxFQUFFLEVBQUUsRUFBRSxFQUFFO0tBQ2hFLENBQUE7QUFDSCxDQUFDLENBQUE7QUFYWSxRQUFBLFVBQVUsY0FXdEI7QUFFTSxNQUFNLFdBQVcsR0FBRyxDQUFDLFFBQWtCLEVBQUUsYUFBdUMsRUFBZSxFQUFFO0lBQ3RHLE1BQU0sRUFDSixhQUFhLEVBQUUsQ0FBQyxFQUNoQixHQUFHLElBQUksRUFDUixHQUFHLFFBQVEsQ0FBQTtJQUVaLE9BQU87UUFDTCxHQUFHLElBQUk7UUFDUCxHQUFHLGFBQWEsSUFBSSxFQUFFLGFBQWEsRUFBRSxJQUFBLGtCQUFVLEVBQUMsYUFBYSxDQUFDLEVBQUU7UUFDaEUsTUFBTSxFQUFFLEVBQUUsSUFBSSxFQUFFLEVBQUUsSUFBSSxFQUFFLHVCQUF1QixFQUFFLEVBQUU7S0FDcEQsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQVhZLFFBQUEsV0FBVyxlQVd2QiJ9